import React from 'react'
import { makeStyles } from '@mui/styles'
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
const useStyles = makeStyles((theme) => ({
  close: {
    width: 40,
    minWidth: 40,
    borderRadius: '50%',
    height: 40,
    padding: 0,
  },
  dialogTitle: {
    padding: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(0, 3, 1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1.5, 1),
    },
  },
  visibleStyle: {
    overflowY: 'visible',
  },
}))

export default function Modal({
  open = false,
  onClose,
  fullWidth = true,
  maxWidth = 'sm',
  disableCloseButton,
  children,
  isOverflowVisible,
  paperWidthSm = '',
  disableEnforceFocus = false,
  title = '',
}) {
  const classes = useStyles()

  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      aria-labelledby="max-width-dialog-title"
      classes={{
        paper: isOverflowVisible && classes.visibleStyle,
        paperWidthSm,
      }}
      disableEnforceFocus={disableEnforceFocus}
    >
      {!disableCloseButton && (
        <DialogTitle
          id="max-width-dialog-title"
          className={classes.dialogTitle}
        >
          <Button onClick={onClose} variant="text" className={classes.close}>
            <CloseOutlinedIcon />
          </Button>
          {title}
        </DialogTitle>
      )}
      <DialogContent
        className={classes.dialogContent}
        style={{ overflowY: isOverflowVisible ? 'visible' : 'auto' }}
      >
        <DialogContentText component="div">{children}</DialogContentText>
      </DialogContent>
    </Dialog>
  )
}
